/**
 * **********************************
 * System Setting Routes Components *
 * **********************************
 */
const ChooseTimezone = () => import('@/components/SysSettings/ChooseTimezone');
const Miscellaneous = () =>
  import('@/components/SysSettings/Miscellaneous/Miscellaneous');

const timeZone = {
  link: '/configuration/timezone',
  title: 'Timezone',
  path: 'timezone',
  component: ChooseTimezone,
  permission: [
    {
      action: 'manage',
      entity: 'organisation'
    }
  ],
  meta: {
    id: 'configuration__timezone-tab'
  }
};

const approvalSettings = {
  link: '/configuration/approval-settings',
  title: 'Approval Settings',
  path: 'approval-settings',
  component: Miscellaneous,
  permission: [
    {
      action: 'manage',
      entity: 'discovery_approval_setting'
    }
  ],
  meta: {
    permission: [
      {
        action: 'manage',
        entity: 'discovery_approval_setting'
      }
    ],
    id: 'configuration__approval-settings-tab'
  }
};

export { timeZone, approvalSettings };
